<template>
<div>处理中，即将返回</div>
</template>

<script>
import { bindMobileThirdAccount } from "api/user/auth/login";
import { showMessage } from "api/base/mobile/message";

export default {
  name: "LoginSuccess",
  data() {
    return {
      user_id: '',
      callbackType: '',
      thirdType: '',
      accessToken: '',
      openid: '',
      target: '',
    }
  },
  mounted() {
    this.callbackType = this.$route.params.callback_type
    this.thirdType = this.$route.params.third_type
    if(this.$route.query.user_id){
      this.user_id = this.$route.query.user_id
    }
    else if(this.$route.query.target){
      this.target = this.$route.query.target
    }
    const that = this
    if(QC.Login.check()){
      QC.Login.getMe(function (openId, accessToken) {
        that.accessToken = accessToken
        that.openid = openId
        that.bindThirdAccount()
      });
    }
  },
  methods: {
    bindThirdAccount() {
      let data = {
        'accessToken': this.accessToken,
        'open_id': this.openid,
        'platform': 'mobile'
      }
      if(this.user_id){
        data['user_id'] = this.user_id
      }
      else if (this.target){
        data['target'] = this.target
      }
      const that = this
      bindMobileThirdAccount(this.thirdType, this.callbackType, data).then(res => {
        if(that.user_id){
          if(res.code == 0){
            that.$router.push('/mobile/center/account')
          }
          else {
            showMessage(res.error).then(res => {
              that.$router.push('/mobile/center/account')
            })
          }
        }
        else {
          if(res.code == 0){
            location.href = that.target
          }
          else if(res.code == 1){
            window.newThirdBindCellphone(res.token, that.target)
            that.$router.push(that.target)
          }
          else if(res.code == 2){
            location.href = res.notify_session_url + '&' + that.target
            // that.$router.push(res.notify_session_url + '&' + that.target)
          }
          else {
            showMessage(res.error).then(res => {
              that.loginModal.visible = true
            })
          }
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
